
import { Component, Mixins, Watch } from "vue-property-decorator";
import { Rectangle, Vector, Size } from "../../../domain/drawing";
import { AsyncRequestPool } from "../../../utilities";
import { MouseTrackableMixin } from ".";

@Component({
})
export default class RectangleLayoutableMixin extends Mixins(MouseTrackableMixin) {
  data(): any {
    return {
      rectangleLayouterRequestPool: new AsyncRequestPool<Rectangle, { layoutingVector: Vector, fixedAspectRatio: number }>(),
    };
  }
  rectangleLayouterRequestPool: AsyncRequestPool<Rectangle, { layoutingVector: Vector, fixedAspectRatio: number }>;

  get isRectangleLayouting(): boolean {
    return this.rectangleLayouterRequestPool.isProcessing
      && !!this.rectangleLayouterRequestPool.processingRequest.source.layoutingVector
      && !this.rectangleLayouterRequestPool.processingRequest.source.layoutingVector.to;
  }

  get layouterRectangle(): Rectangle {
    return this.isRectangleLayouterVisible
      ? this.toAspectAdjustedRectangle(Rectangle.from(new Vector(this.rectangleLayouterRequestPool.processingRequest.source.layoutingVector.from, this.mouseLocation)))
      : new Rectangle();
  }

  toAspectAdjustedRectangle(source: Rectangle): Rectangle {
    return new Rectangle(
      source.topLeft,
      this.toAspectAdjustedSize(source.size)
    );
  }

  toAspectAdjustedSize(source: Size): Size {
    const aspectRatio = source.width / source.height;
    const fixedAspectRatio = (this.rectangleLayouterRequestPool.processingRequest && this.rectangleLayouterRequestPool.processingRequest.source.fixedAspectRatio)
      ? this.rectangleLayouterRequestPool.processingRequest.source.fixedAspectRatio
      : 0;
    return (0 < fixedAspectRatio)
      ? new Size(
        (fixedAspectRatio < aspectRatio) ? source.width : source.height * fixedAspectRatio,
        (aspectRatio < fixedAspectRatio) ? source.height : source.width / fixedAspectRatio
      )
      : source.clone();
  }

  get isRectangleLayouterVisible(): boolean {
    return this.isRectangleLayouting
      && !!this.rectangleLayouterRequestPool.processingRequest.source.layoutingVector.from;
  }

  @Watch("isMouseLeftButtonPressed")
  onMouseLeftButtonClickedForRectangleLayouter(newValue: boolean, oldValue: boolean) {
    if (!this.rectangleLayouterRequestPool.isProcessing || !this.rectangleLayouterRequestPool.processingRequest.source.layoutingVector) {
      return;
    }
    if (newValue) {
      this.rectangleLayouterRequestPool.processingRequest.source.layoutingVector = new Vector(this.mouseLocation, null);
    } else if (this.rectangleLayouterRequestPool.processingRequest.source.layoutingVector.from) {
      this.rectangleLayouterRequestPool.processingRequest.source.layoutingVector = new Vector(this.rectangleLayouterRequestPool.processingRequest.source.layoutingVector.from, this.mouseLocation);
    }
  }

  async layoutRectangle(fixedAspectRatio: number = 0): Promise<Rectangle> {
    return this.rectangleLayouterRequestPool.request(
      {
        layoutingVector: new Vector(null, null),
        fixedAspectRatio,
      },
      this,
      async (source: { layoutingVector: Vector, fixedAspectRatio: number }) => {
        await this.$wait(() => !this.isRectangleLayouting);
        return (!source.layoutingVector || !source.layoutingVector.from || !source.layoutingVector.to)
          ? null
          : this.toAspectAdjustedRectangle(Rectangle.from(source.layoutingVector));
      },
    );
  }

  cancelRectangleLayouting(): void {
    this.rectangleLayouterRequestPool.cancel(this);
  }
}
